module.exports = __webpack_public_path__ + "static/media/Travis Messina.50ba802a.png";